module.exports = __webpack_public_path__ + "static/media/card-ganbei.654979dd.png";